<template>
  <div class="search-container">
    <div class="p-grid">
      <div class="p-col">
        <div class="p-input-icon-right search-input">
          <i
            class="pi pi-search"
            style="left: 0.5rem !important"
            v-if="!chips.length"
          />
          <i
            class="pi pi-angle-down"
            style="cursor: pointer"
            @click="$refs.searchFilters.toggle($event)"
          />
          <Chips
            type="text"
            style="width: 100%"
            :class="[{ 'search-input-placeholder-active': !chips.length }]"
            :placeholder="!chips.length ? 'Pesquisar' : ''"
            separator=","
            :modelValue="chips"
            @keyup.enter="search()"
            @add="addTerm($event)"
            @remove="removeChip($event)"
          />
          <div id="search-options" style="width: 95%"></div>
          <SearchContainer
            v-if="isMounted"
            ref="searchFilters"
            :dismissable="false"
          >
            <div
              class="p-fluid search-options-fields"
              :style="
                optionsHeight
                  ? { maxHeight: optionsHeight, paddingRight: '10px' }
                  : {}
              "
            >
              <!-- Cliente -->
              <div class="p-field p-grid" v-if="isVet">
                <label class="p-col-4">
                  <span
                    class="material-icons search-option-icon p-mr-3"
                    style="color: #396df4"
                  >
                    assignment_ind
                  </span>
                  Cliente
                </label>
                <div class="p-col-8">
                  <Dropdown
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="150px"
                    filter
                    v-model="searchFilters.customers.value"
                    :options="searchFilters.customers.options"
                    @click="fetchOptions('customers')"
                  >
                  </Dropdown>
                </div>
              </div>
              <!-- ID -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    tag
                  </span>
                  ID
                </label>
                <div
                  class="p-col-8"
                  v-tooltip.top="'Informar vários ids separados por vírgula.'"
                >
                  <InputText v-model="searchFilters.id.value" />
                </div>
              </div>
              <!-- Tipo -->
              <div class="p-field p-grid">
                <label class="p-col-4">Tipo de Serviço</label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('type')"
                    v-model="searchFilters.type.value"
                    :options="searchFilters.type.options"
                    optionLabel="path"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="250px"
                    filter
                  >
                    <template #option="props">
                      <ServiceType
                        :value="props.option.path"
                        :background="props.option.color"
                      ></ServiceType>
                    </template>
                  </MultiSelect>
                </div>
                <div class="p-col-4"></div>
                <div class="p-col-8 p-mt-3">
                  <div class="p-field-checkbox">
                    <Checkbox
                      name="subtype"
                      v-model="searchFilters.type.subtype"
                      :binary="true"
                    />
                    <label for="subtype"> Incluir Sub Tipos </label>
                  </div>
                </div>
              </div>
              <!-- Fazenda -->
              <div class="p-field p-grid" v-if="!isVet || !!customer">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    map
                  </span>
                  Fazenda
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('farms')"
                    v-model="searchFilters.farms.value"
                    :options="searchFilters.farms.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="150px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <!-- Data -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    event
                  </span>
                  Data entre
                </label>
                <div class="p-col-4">
                  <Calendar
                    v-model="searchFilters.date.value[0]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="dateRange"
                    :locale="$locales.calendar.ptBR"
                    appendTo="body"
                  />
                </div>
                <div class="p-col-4">
                  <Calendar
                    v-model="searchFilters.date.value[1]"
                    dateFormat="dd/mm/yy"
                    showIcon
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :yearRange="dateRange"
                    :locale="$locales.calendar.ptBR"
                    appendTo="body"
                  />
                </div>
              </div>
              <!-- Situação -->
              <div class="p-field p-grid" v-if="!isVet || !!customer">
                <label class="p-col-4">
                  <span class="material-icons search-option-icon p-mr-3">
                    info
                  </span>
                  Situação
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('situation')"
                    v-model="searchFilters.situation.value"
                    :options="searchFilters.situation.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="150px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
              <!-- Valor -->
              <div class="p-field p-grid">
                <label class="p-col-4">
                  <span
                    class="material-icons search-option-icon p-mr-3"
                    style="font-size: 22px"
                  >
                    attach_money
                  </span>
                  Valor entre
                </label>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.value.value[0]"
                    :minFractionDigits="2"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                  />
                </div>
                <div class="p-col-4">
                  <InputNumber
                    v-model="searchFilters.value.value[1]"
                    :minFractionDigits="2"
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                  />
                </div>
                <div class="p-col p-lg-4"></div>
                <div class="p-col-fixed p-mt-3">
                  <div class="p-field-radiobutton">
                    <RadioButton
                      name="valueType"
                      value="totalValue"
                      v-model="searchFilters.value.valueType"
                    />
                    <label for="totalValue">Valor Total</label>
                  </div>
                </div>
                <div class="p-col-fixed p-mt-3 p-ml-1">
                  <div class="p-field-radiobutton">
                    <RadioButton
                      name="valueType"
                      value="bovineValue"
                      v-model="searchFilters.value.valueType"
                    />
                    <label for="bovineValue">Valor por Bovino</label>
                  </div>
                </div>
              </div>
              <!-- Veterinário -->
              <div class="p-field p-grid" v-if="!isVet">
                <label class="p-col-4">
                  <span
                    class="material-icons search-option-icon p-mr-3"
                    style="color: #396df4"
                  >
                    assignment_ind
                  </span>
                  Veterinário
                </label>
                <div class="p-col-8">
                  <MultiSelect
                    @click="fetchOptions('vets')"
                    v-model="searchFilters.vets.value"
                    :options="searchFilters.vets.options"
                    optionLabel="name"
                    emptyFilterMessage="Nenhum resultado"
                    appendTo="body"
                    scrollHeight="150px"
                    filter
                  >
                  </MultiSelect>
                </div>
              </div>
            </div>
            <div class="p-fluid" style="margin-top: 20px">
              <div class="p-grid p-jc-end">
                <div class="p-col-4">
                  <Button label="Pesquisar" @click="search()" />
                </div>
              </div>
            </div>
          </SearchContainer>
        </div>
      </div>
      <div class="p-col-3">
        <Dropdown
          v-model="searchOrder.orderField"
          :options="searchOrderOptions"
          optionLabel="name"
          placeholder="Ordenar por"
          @change="search()"
          style="width: 100%"
        />
      </div>
      <div class="p-col-fixed search-order" style="width: 50px">
        <Button
          :icon="orderIcon"
          class="p-button-text p-button-plain"
          @click="changeOrder()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchContainer from '../../../components/SearchContainer.vue';
import {
  FarmApi,
  ServiceTypeApi,
  VetApi,
  VetCustomerApi,
} from '../../../services/api';
import ServiceType from './ServiceType.vue';
import {
  buildQuery,
  getChipValue,
  useIdsFilter,
  useTextFilter,
  useDateRangeFilter,
  useTermFilter,
  useValueRangeFilter,
} from '../../../lib/search';

function useTypeFilter() {
  const filters = useIdsFilter(
    'Tipo',
    'parentTypeId',
    'path',
    ServiceTypeApi.fetch
  );
  return {
    ...filters,
    subtype: true,
    chips: (name, value) => value.map((val) => getChipValue(name, val.path)),
    query(value) {
      if (this.subtype) {
        return { parentTypeId: value.map((v) => v.id) };
      }
      return { typeId: value.map((v) => v.id) };
    },
  };
}

function useSituationFilter() {
  const situations = [
    { id: 'pending', name: 'Pendente' },
    { id: 'partial', name: 'Parcial' },
    { id: 'done', name: 'Concluído' },
  ];
  const callback = () => ({ results: Promise.resolve(situations) });
  return useIdsFilter('Situação', 'situation', 'name', callback);
}

function useValueFilter() {
  const filters = useValueRangeFilter('Valor', 'value');
  return {
    ...filters,
    valueType: 'totalValue',
    query(value) {
      if (!value[0] && !value[1]) {
        return {};
      }
      return { [this.valueType]: value.join(',') };
    },
  };
}

function useVetFilter() {
  const callback = async () => {
    const response = await VetApi.fetch();
    response.results = response.results.map((res) => ({
      id: res.vetAccount.id,
      name: res.vetAccount.name,
    }));
    return response;
  };
  return useIdsFilter('Veterinário', 'vetId', 'name', callback);
}

function useCustomerFilter() {
  const callback = async () => {
    const response = await VetCustomerApi.fetch();
    response.results = response.results.map((res) => ({
      id: res.account.id,
      name: res.account.name,
    }));
    return response;
  };
  return useIdsFilter('Cliente', 'customerId', 'name', callback);
}

export default {
  name: 'ServiceSearch',
  props: {
    optionsHeight: {
      type: [Number, String],
      default: () => '70vh',
    },
  },
  components: {
    SearchContainer,
    ServiceType,
  },
  data() {
    return {
      dateRange: `${this.$dayjs()
        .subtract(10, 'y')
        .format('YYYY')}:${this.$dayjs().add(10, 'y').format('YYYY')}`,
      chips: [],
      customer: null,
      searchFilters: {
        term: useTermFilter(),
        id: useTextFilter('ID', 'id'),
        type: useTypeFilter(),
        situation: useSituationFilter(),
        farms: useIdsFilter('Fazenda', 'farmId', 'name', FarmApi.fetch),
        value: useValueFilter(),
        date: useDateRangeFilter('Data', 'date'),
        vets: useVetFilter(),
        customers: useCustomerFilter(),
      },
      searchOrder: {
        orderField: null,
        order: '',
      },
      isMounted: false,
    };
  },
  async created() {
    const { chips } = this.buildQuery();
    this.chips = chips;
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    orderIcon() {
      if (!this.searchOrder.order) {
        return 'pi pi-sort-alt';
      }
      return this.searchOrder.order === 'asc'
        ? 'pi pi-sort-amount-up'
        : 'pi pi-sort-amount-down';
    },
    ...mapGetters('app', ['isVetAccount']),
    isVet() {
      return (
        this.isVetAccount && !(this.$route.name || '').includes('customer')
      );
    },
    searchOrderOptions() {
      if (this.isVet) {
        return [
          { name: 'ID', value: 'id' },
          { name: 'Data Início', value: 'dateStart' },
          { name: 'Data Fim', value: 'dateEnd' },
          { name: 'Valor Total', value: 'totalValue' },
          { name: 'Valor por Bovino', value: 'bovineValue' },
        ];
      }
      return [
        { name: 'ID', value: 'id' },
        { name: 'Data Início', value: 'dateStart' },
        { name: 'Data Fim', value: 'dateEnd' },
        { name: 'Tipo de Serviço', value: 'type.path' },
        { name: 'Fazenda', value: 'farm.name' },
        { name: 'Valor Total', value: 'totalValue' },
        { name: 'Valor por Bovino', value: 'bovineValue' },
      ];
    },
  },
  watch: {
    async 'searchFilters.customers.value'(newVal) {
      this.customer = newVal?.id ? newVal : null;
      this.resetCustomerData();
      if (this.customer?.id) {
        const loginData = await VetCustomerApi.login({
          accountId: this.customer?.id,
        });
        this.customer.accessToken = loginData.accessToken;
      }
    },
  },
  methods: {
    async fetchOptions(field) {
      const option = this.searchFilters[field];
      if (option && option.fetchOptions && !option.options.length) {
        option.options = await option.fetchOptions(
          {},
          this.searchFilters,
          this.getApiOptions()
        );
      }
    },
    addTerm({ value }) {
      const term = value
        .filter((v) => !v.includes(':') || v.includes('Termo: '))
        .map((v) => v.replace('Termo: ', ''));
      this.searchFilters.term.value = term;
    },
    removeChip(event) {
      const [name, value] = event.value[0].split(': ');
      const field = Object.keys(this.searchFilters).find(
        (key) => this.searchFilters?.[key]?.name === name
      );
      const searchFilter = this.searchFilters[field];
      if (searchFilter.removeValue) {
        this.searchFilters[field].value = searchFilter.removeValue(
          searchFilter.value,
          value
        );
      }
      this.search();
    },
    changeOrder() {
      this.searchOrder.order =
        this.searchOrder.order === 'asc' ? 'desc' : 'asc';
      this.search();
    },
    buildQuery() {
      return buildQuery(this.searchFilters, this.searchOrder);
    },
    search() {
      const { query, chips } = this.buildQuery();
      this.chips = chips;
      this.$emit('search', { query });
      this.$refs.searchFilters.hide();
    },
    getApiOptions() {
      return {
        accessToken: this.customer?.accessToken,
      };
    },
    resetCustomerData() {
      const keys = ['type', 'farms'];
      keys.forEach((key) => {
        this.searchFilters[key].value = [];
        this.searchFilters[key].options = [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  ::v-deep .p-overlaypanel {
    left: 0 !important;
  }
  ::v-deep .p-overlaypanel:after,
  .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
  ::v-deep .p-overlaypanel:before {
    left: calc(var(--overlayArrowLeft, 0) + 0.6rem);
  }
}
.search-option-icon {
  font-size: 18px;
  color: #495057;
}
.search-options-fields {
  overflow-y: auto;
  overflow-x: hidden;
}
.search-input {
  width: 100%;
  ::v-deep .p-chips-multiple-container {
    width: 100%;
    display: inline;
  }
}
.search-input-placeholder-active {
  ::v-deep input {
    padding-left: 1.5rem !important;
  }
}
.search-order {
  button {
    background-color: white;
  }
}
.search-order .p-button {
  border: 1px solid #ced4da !important;
  border-radius: 3px !important;
}
@media (max-width: 600px) {
  .search-container .p-col {
    flex-grow: unset !important;
    flex-basis: unset !important;
    width: 100%;
  }
  .search-container .p-col-3 {
    flex-grow: 1;
    flex-basis: 0;
  }
  .search-order {
    width: 47px !important;
  }
}
</style>
